var SupportBaseTicketModel, SupportEmailFormModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportBaseTicketModel = require('./base_ticket_model');

SupportEmailFormModel = (function(superClass) {
  extend(SupportEmailFormModel, superClass);

  function SupportEmailFormModel() {
    return SupportEmailFormModel.__super__.constructor.apply(this, arguments);
  }

  SupportEmailFormModel.prototype.initialize = function() {
    SupportBaseTicketModel.prototype.initialize.apply(this, arguments);
    this.getDefaultEmailForm();
    this.setEmailForm();
    return this.initializeEmailFormObjectsCount();
  };

  SupportEmailFormModel.prototype.setEmailForm = function() {
    var contentModelFlexibleStepThree, ref;
    contentModelFlexibleStepThree = (ref = Groupon.Support.ContentModel) != null ? ref.flexibleStepThree : void 0;
    if (_.isEmpty(contentModelFlexibleStepThree)) {
      this.emailForm = $.extend(true, {}, this.defaultEmailForm);
      return this.isFlexibleStepThree = false;
    } else {
      this.emailForm = $.extend(true, {}, contentModelFlexibleStepThree);
      this.addRequiredItemsToFlexibleEmailForm();
      return this.isFlexibleStepThree = true;
    }
  };

  SupportEmailFormModel.prototype.initializeEmailFormObjectsCount = function() {
    return this.emailFormObjectsCount = {
      phone_number: 0,
      email_address: 0,
      user_name: 0,
      number: 0,
      text_field_paragraph: 0,
      text_field_line: 0,
      attachment: 0,
      calendar_date: 0,
      calendar_with_hour_slot: 0,
      dropdown: 0,
      checkbox: 0,
      text_paragraph: 0
    };
  };

  SupportEmailFormModel.prototype.addRequiredItemsToFlexibleEmailForm = function() {
    var emailAddress, phoneNumber, recaptcha, ref, userName;
    phoneNumber = 'phone_number';
    emailAddress = 'email_address';
    userName = 'user_name';
    recaptcha = 'recaptcha';
    if (window.isUS()) {
      return this.addRequiredItemsToFlexibleEmailFormForUS();
    } else if (this.isMethodOfContactByPhone()) {
      return this.addDefaultFormObjectsToEmailForm();
    } else {
      if (!(((ref = this.emailForm.objects) != null ? ref.length : void 0) > 0)) {
        this.emailForm.objects = [];
      }
      this.addObjectToEmailForm(this.checkConditionsToAddPhoneNumbers(phoneNumber), phoneNumber);
      this.addObjectToEmailForm(!((typeof currentUser !== "undefined" && currentUser !== null ? currentUser.email : void 0) != null) && !(this.isObjectTypeAlreadyPresent(emailAddress)), emailAddress);
      this.addObjectToEmailForm(this.checkIfUserNameIsEmpty(), userName);
      return this.addObjectToEmailForm(this.isRecaptchaEnabled(), recaptcha);
    }
  };

  SupportEmailFormModel.prototype.checkIfUserNameIsEmpty = function() {
    return _.isEmpty(typeof currentUser !== "undefined" && currentUser !== null ? currentUser.firstName : void 0) && _.isEmpty(typeof currentUser !== "undefined" && currentUser !== null ? currentUser.lastName : void 0);
  };

  SupportEmailFormModel.prototype.checkConditionsToAddPhoneNumbers = function(phoneNumber) {
    return !(this.isObjectTypeAlreadyPresent(phoneNumber)) && !window.priorityViewsEnabled();
  };

  SupportEmailFormModel.prototype.isObjectTypeAlreadyPresent = function(flexStepThreeObjType) {
    var flexibleStepThreeObj, i, len, ref;
    ref = this.emailForm.objects;
    for (i = 0, len = ref.length; i < len; i++) {
      flexibleStepThreeObj = ref[i];
      if (flexibleStepThreeObj.type === flexStepThreeObjType) {
        return true;
      }
    }
    return false;
  };

  SupportEmailFormModel.prototype.addObjectToEmailForm = function(criteriaToAdd, objectToBeAdded) {
    var item;
    if (criteriaToAdd) {
      item = this.getRequiredItem(objectToBeAdded);
      if (item.append) {
        return this.emailForm.objects.push(item);
      } else {
        return this.emailForm.objects.splice(0, 0, item);
      }
    }
  };

  SupportEmailFormModel.prototype.addDefaultFormObjectsToEmailForm = function() {
    return this.emailForm.objects = $.extend(true, [], this.defaultEmailForm.objects);
  };

  SupportEmailFormModel.prototype.getEmailFormInputObjects = function() {
    var ref;
    if (((ref = this.emailForm.objects) != null ? ref.length : void 0) > 0) {
      return this.emailForm.objects;
    } else {
      return this.defaultEmailForm.objects;
    }
  };

  SupportEmailFormModel.prototype.isMethodOfContactByPhone = function() {
    return this.emailForm.method_of_contact === 'phone';
  };

  SupportEmailFormModel.prototype.isMethodOfContactByPhoneWithEmail = function() {
    return this.emailForm.method_of_contact === 'phone_with_email';
  };

  SupportEmailFormModel.prototype.numberOfRedemptionLocationsAvailable = function() {
    var ref, ref1;
    if (((ref = Groupon.Support.currentOrder) != null ? (ref1 = ref.dealOption) != null ? ref1.redemptionLocations : void 0 : void 0) != null) {
      return Groupon.Support.currentOrder.dealOption.redemptionLocations.length;
    } else {
      return 0;
    }
  };

  SupportEmailFormModel.prototype.isFTRDropdownCombinationSlected = function() {
    var FTRDropDownCombination;
    FTRDropDownCombination = [
      {
        categoryId: "a_problem_with_the_business",
        subCategoryId: "the_business_is_not_returning_my_calls_or_emails"
      }, {
        categoryId: "an_expired_groupon",
        subCategoryId: "the_business_is_not_returning_my_calls_or_emails"
      }
    ];
    return this.checkIfAnyDropdownCombinationMatches(FTRDropDownCombination);
  };

  SupportEmailFormModel.prototype.checkIfAnyDropdownCombinationMatches = function(dropdownCombo) {
    return _.some(dropdownCombo, (function(_this) {
      return function(dropdown) {
        var categoryId, subCategoryId;
        categoryId = dropdown.categoryId, subCategoryId = dropdown.subCategoryId;
        return (_this.parentCategoryId.indexOf(categoryId) > -1) && (_this.reasonId.indexOf(subCategoryId) > -1);
      };
    })(this));
  };

  SupportEmailFormModel.prototype.getDefaultEmailForm = function() {
    if (this.defaultEmailForm != null) {
      return this.defaultEmailForm;
    }
    if (window.isUS()) {
      return this.defaultEmailForm = this.getDefaultEmailFormForUS();
    } else {
      return this.defaultEmailForm = this.getDefaultEmailFormForEMEA();
    }
  };

  SupportEmailFormModel.prototype.getDefaultEmailFormForUS = function() {
    var dynamicEmailForm, objects;
    objects = [];
    if (this.canShowUserIdentificatioView()) {
      objects.push({
        type: "user_identification",
        required: "true"
      });
    }
    if (this.canShowMerchantLocationInfoView()) {
      objects.push({
        type: "merchant_location",
        required: "true"
      });
    }
    if (this.canShowUserContactInfoView()) {
      objects.push({
        type: "user_contact_info",
        required: "true"
      });
    }
    objects.push({
      type: "description",
      required: "true",
      append: true
    });
    if (this.isRecaptchaEnabled()) {
      objects.push({
        type: "recaptcha",
        required: "true",
        append: true
      });
    }
    return dynamicEmailForm = {
      method_of_contact: "email",
      objects: objects
    };
  };

  SupportEmailFormModel.prototype.getDefaultEmailFormForEMEA = function() {
    var dynamicEmailForm;
    dynamicEmailForm = {
      method_of_contact: "email",
      objects: [
        {
          type: "user_name",
          label: I18n.translate('js.modules.support.userlabel'),
          required: "true",
          additional_attributes: {
            maximum_number_of_characters_or_digits: ""
          }
        }, {
          type: "email_address",
          label: I18n.translate('js.modules.support.emaillabel'),
          required: "true"
        }, {
          type: "phone_number",
          label: I18n.translate('js.modules.support.user_phone_number'),
          required: "false"
        }, {
          type: "text_field_paragraph",
          label: I18n.translate('js.modules.support.whatson'),
          required: "true",
          additional_attributes: {
            maximum_number_of_characters_or_digits: "2000"
          }
        }, {
          type: "attachment",
          label: I18n.translate('js.modules.support.attach_file'),
          required: "false"
        }, {
          type: "recaptcha",
          required: "true",
          append: true
        }
      ]
    };
    if (!this.isRecaptchaEnabled()) {
      dynamicEmailForm.objects = _.reject(dynamicEmailForm.objects, function(object) {
        return object.type === 'recaptcha';
      });
    }
    if (!this.isFileUploadEnabled()) {
      dynamicEmailForm.objects = _.reject(dynamicEmailForm.objects, function(object) {
        return object.type === 'attachment';
      });
    }
    if (!this.canShowUserIdentificatioView()) {
      dynamicEmailForm.objects = _.reject(dynamicEmailForm.objects, function(object) {
        return object.type === 'email_address';
      });
    }
    if (!this.checkIfUserNameIsEmpty()) {
      dynamicEmailForm.objects = _.reject(dynamicEmailForm.objects, function(object) {
        return object.type === 'user_name';
      });
    }
    return dynamicEmailForm;
  };

  SupportEmailFormModel.prototype.isRecaptchaEnabled = function() {
    return Groupon.Support.FeatureFlagModel.isRecaptchaEnabled();
  };

  SupportEmailFormModel.prototype.isFileUploadEnabled = function() {
    return window.evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.fileUpload : void 0);
  };

  SupportEmailFormModel.prototype.getRequiredItem = function(item) {
    var defaultEmailFormObjects, i, len, obj, requiredItem;
    defaultEmailFormObjects = this.getDefaultEmailForm().objects;
    requiredItem = {};
    for (i = 0, len = defaultEmailFormObjects.length; i < len; i++) {
      obj = defaultEmailFormObjects[i];
      if (obj.type === item) {
        requiredItem = obj;
      }
    }
    return requiredItem;
  };

  SupportEmailFormModel.prototype.canShowUserIdentificatioView = function() {
    return !isUserLogged() || (currentUser.email == null);
  };

  SupportEmailFormModel.prototype.canShowMerchantLocationInfoView = function() {
    return Groupon.Support.FeatureFlagModel.isShowMerchantInfoFieldsEnabled() && (this.isFTRDropdownCombinationSlected() && this.numberOfRedemptionLocationsAvailable() !== 1);
  };

  SupportEmailFormModel.prototype.canShowUserContactInfoView = function() {
    return Groupon.Support.FeatureFlagModel.isShowUserContactInfoFieldsEnabled() && this.isFTRDropdownCombinationSlected();
  };

  SupportEmailFormModel.prototype.addRequiredItemsToFlexibleEmailFormForUS = function() {
    var defaultEmailFormObjects, objects, objectsToBeAppended, objectsToBePrepended, ref, ref1;
    if (((ref = this.emailForm) != null ? (ref1 = ref.objects) != null ? ref1.length : void 0 : void 0) > 0) {
      defaultEmailFormObjects = this.getDefaultEmailForm().objects;
      objectsToBeAppended = [];
      objectsToBePrepended = [];
      _.each(defaultEmailFormObjects, function(obj) {
        if (obj.append) {
          return objectsToBeAppended.push(obj);
        } else {
          return objectsToBePrepended.push(obj);
        }
      });
      this.addRequiredItemsToFlexibleStepThreeForCMSUS(objectsToBePrepended);
      objects = $.merge($.merge(objectsToBePrepended, this.emailForm.objects), objectsToBeAppended);
      return this.emailForm.objects = objects;
    }
  };

  SupportEmailFormModel.prototype.addRequiredItemsToFlexibleStepThreeForCMSUS = function(objectsToBePrepended) {
    var phoneNumberDropDownCombination, textFieldDropDownCombination, userContactInfoDropDownCombination;
    if (objectsToBePrepended == null) {
      objectsToBePrepended = [];
    }
    if (window.evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.shouldDisplayCMSContentForUS : void 0)) {
      userContactInfoDropDownCombination = [
        {
          categoryId: "a_problem_with_the_business",
          subCategoryId: "the_business_won_t_accept_my_groupon"
        }
      ];
      phoneNumberDropDownCombination = [
        {
          categoryId: "a_problem_with_the_business",
          subCategoryId: "the_business_is_closed"
        }
      ];
      textFieldDropDownCombination = [
        {
          categoryId: "a_problem_with_the_business",
          subCategoryId: "the_business_won_t_accept_my_groupon"
        }
      ];
      if (this.checkIfAnyDropdownCombinationMatches(userContactInfoDropDownCombination)) {
        objectsToBePrepended.push({
          type: "user_contact_info",
          required: "true"
        });
      }
      if (this.checkIfAnyDropdownCombinationMatches(phoneNumberDropDownCombination)) {
        objectsToBePrepended.push({
          type: "phone_number",
          label: I18n.translate('js.modules.support.phone_number_called'),
          required: "false"
        });
      }
      if (this.checkIfAnyDropdownCombinationMatches(textFieldDropDownCombination)) {
        objectsToBePrepended.push({
          type: "text_field_line",
          label: I18n.translate('js.modules.support.location_visited'),
          required: "true"
        });
      }
      return objectsToBePrepended;
    }
  };

  return SupportEmailFormModel;

})(SupportBaseTicketModel);

module.exports = SupportEmailFormModel;

//# sourceMappingURL=data:application/json;base64,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
